// libraries
import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router } from "react-router-dom";
import smoothscroll from "smoothscroll-polyfill";
import HttpsRedirect from "react-https-redirect";

// styles
import "./index.css";
import "./styles/custom.scss";

import "antd/dist/antd.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "swiper/swiper.scss";
import "swiper/modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";
import "react-image-lightbox/style.css";
import "rc-pagination/assets/index.css";

// components
import App from "./App";

// provider
import { UserProvider } from "src/context/User";
import { AdminAuthProvider } from "src/context/AdminAuthContext";
import { UserAuthProvider } from "src/context/UserAuthContext";

smoothscroll.polyfill();

ReactDOM.render(
  // UserProvider will be removed in future
  <UserProvider>
    <UserAuthProvider>
      <AdminAuthProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={2}
        />
        <Router>
          <HttpsRedirect>
            <App />
          </HttpsRedirect>
        </Router>
      </AdminAuthProvider>
    </UserAuthProvider>
  </UserProvider>,
  document.getElementById("root")
);
